import React from "react";

export const ApprovalApproved = () => {
  return (
    <img src="/images/approvalApproved.svg" alt="" style={{ height: "40px", width: "40px", borderRadius: "50%" }} />
  )
}
